import type { FC } from "react";
import ProductSearchListItem from "./ProductSearchListItem";
import { ProductSearchListItemProps } from "./ProductSearchListItem";
import useIsMobile from "@/hooks/useIsMobile";
import useTranslations from "@/i18n/useTranslations";

interface LearnerFavoritesSectionProps {
  items: ProductSearchListItemProps[];
  sectionHeader?: string;
  location?: string;
}

const LearnerFavoritesSection: FC<LearnerFavoritesSectionProps> = ({
  items,
  sectionHeader,
  location = "embedded-search",
}) => {
  const t = useTranslations("Search");
  const isMobile = useIsMobile();
  const displayedItems = items.slice(0, isMobile ? 3 : 6);

  if (displayedItems.length === 0) return null;

  return (
    <div>
      <span className="elm-p2 text-gray-800 font-bold uppercase">
        {sectionHeader ?? t("learnerFavorites")}
      </span>
      <ul className="list-none !p-0 my-0 grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
        {displayedItems.map((item, index) => (
          <li key={item.id} className="m-0">
            <ProductSearchListItem
              {...item}
              index={index}
              location={location}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LearnerFavoritesSection;
